import { makeAutoObservable } from 'mobx';

import { DataStore } from 'app/common/data-storage/features/data-storage';
import { PermissionStore } from 'app/railways/domains/access/features/permissions/permissions.store';

import { IUserProfileStore, TUserProfile } from '../../core';

const initialState: TUserProfile = {
  id: 0,
  login: '',
  blocked: false,
  roles: [],
};

export class UserProfileStore implements IUserProfileStore {
  private userData = new DataStore<TUserProfile>(initialState);
  private permsSet = new PermissionStore();

  get data(): TUserProfile {
    return this.userData.data;
  }

  get perms() {
    return this.permsSet.perms;
  }

  constructor() {
    makeAutoObservable(this);
  }

  public setProfile(data: TUserProfile) {
    this.userData.setData(data);
    this.permsSet.fromUser(data);
  }
}
